<template>
    <div class="myloader">
        <fulfilling-square-spinner
        :animation-duration="4000"
        :size="50"
        color="primary"
        />
    </div>
</template>

<script>
import { FulfillingSquareSpinner } from 'epic-spinners'
export default {
    name: 'loadingcomponent',
    components: {
        FulfillingSquareSpinner
    }
}
</script>

<style scoped>
.myloader {
    position:fixed;
    top: 50%;
    left: 50%;
    right:50%;
    bottom:50%;
}
</style>


// WEBPACK FOOTER //
// src/components/loadingSpinner.vue